import { ShieldCheck, Users, Sparkles, Star } from "lucide-react";
import { FIRM } from "@/constants/firmInfo";
import { useLanguage } from "@/i18n/LanguageContext";

// Trust reinforcement strip — horizontal scroll-snap on mobile (feels like a
// ticker), calm centered row on desktop. Placed just below the hero.
export const TrustBadgeStrip = () => {
  const { t } = useLanguage();
  const strip = t("trustStrip");
  const BADGES = [
    { icon: ShieldCheck, label: `${strip[0]} ${FIRM.foundedYear}` },
    { icon: Users, label: strip[1] },
    { icon: Sparkles, label: strip[2] },
    { icon: Star, label: strip[3] },
  ];

  return (
    <section className="bg-white border-b border-slate-200" data-testid="trust-badge-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex sm:flex-wrap sm:items-center sm:justify-center gap-x-10 gap-y-3 overflow-x-auto sm:overflow-visible no-scrollbar snap-x snap-mandatory">
          {BADGES.map((badge) => (
            <div
              key={badge.label}
              className="flex items-center gap-2 text-sm font-medium text-[color:var(--navy-950)] shrink-0 snap-start"
              data-testid="trust-badge-item"
            >
              <badge.icon className="h-4 w-4 text-[color:var(--gold-500)]" />
              {badge.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
